<template>
    <div class="" id="page-content">
        <section class="c-fold-split__wrap">
            <div class="c-fold-split">
                <div class="o-grid">
                    <div class="o-grid-3"></div>
                    <div class="o-grid-6">
                        <div class="c-login">
                            <h1 class="c-login__title">
                                {{ _t('Connexion') }}
                            </h1>
                            <div v-if="confirm.message" class="o-text"
                                :class="{ '-error-form': confirm.state == 'error', '-success-form': confirm.state == 'success' }">
                                <p>{{ confirm.message }}</p>
                            </div>
                            <form class="o-form c-login__form" method="post" autocomplete="on" @submit.prevent="login" data-module="FocusLabel">
                                <div class="o-form__group">
                                    <label class="o-label" for="courriel">{{ _t('Courriel') }}</label>
                                    <input class="o-input" type="text" id="courriel" v-model="email" name="Courriel" required autocomplete="email">
                                </div>
                                <div class="o-form__group">
                                    <label class="o-label" for="psw">{{ _t('Mot de passe') }}</label>
                                    <input class="o-input" type="password" id="psw" name="psw" v-model="password" required autocomplete="current-password">
                                </div>
                                <div class="o-form__button c-login__form__buttons">
                                    <div class="o-text o-form__note">
                                        <p><a :href="resetPasswordLink">{{ _t('Mot de passe oublié ?') }}</a></p>
                                    </div>
                                    <button class="o-button -form-button" type="submit" aria-label="Soumettre le formulaire de connexion">
                                        <span class="o-button__text">{{ _t('Connexion') }}</span>
                                        <span class="sr-only">{{ _t('Soumettre le formulaire de connexion') }}</span>
                                    </button>
                                </div>
                                <!--<div class="o-text c-login__form__note">
                                    <h5>{{ _t('Vous n’avez pas de compte ?') }}</h5>
                                    <p><a :href="resetPasswordLink">{{ _t('Créer un compte') }}</a></p>
                                </div>-->
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>
<script>
import axios from 'axios'

export default {
    name: 'CustomerLogin',
    data() {
        return {
            email: '',
            password: '',
            confirm: {
                state: '',
                message: ''
            },
            resetPasswordLink: '',
            pages: window.ajax_var.pages
        }
    },
    methods: {
        checkLogin() {
            this.resetPasswordLink = window.ajax_var.resetPassword;
            let params = {
                _wpnonce: window.ajax_var.nonce
            }
            axios.get('/wp-json/stereostore/v1/checklogin', { params })
                .then(response => {
                    if (response.data.ID != 0 && response.data.success) {
                        location.href = this.pages.dashboard
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        login() {
            let params = {
                email: this.email,
                password: this.password,
                token: this.$store.state.token,
                _wpnonce: window.ajax_var.nonce,
                redirect: this.pages.dashboard
            }
            axios.post('/wp-json/stereostore/v1/login', params)
                .then(response => {
                    this.confirm = {
                        state: 'success',
                        message: response.data.message
                    }
                    location.href = response.data.redirect_to
                })
                .catch(error => {
                    this.confirm = {
                        state: 'error',
                        message: error.response.data.message
                    }
                })
        }
    },
    mounted() {
        this.checkLogin()
    }
}

</script>